export default __webpack_public_path__ + "static/profile-card-peter-e271edbc5e20928e4ecdb958cd34c287.jpeg";